"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressBar = void 0;
const React = __importStar(require("react"));
const Icon_1 = __importDefault(require("../Icon/Icon"));
const Spacer_1 = __importDefault(require("../Spacer/Spacer"));
const ProgressBar = ({ completionPercent, transitionPeriod = 0.1, color, }) => {
    const percent = Math.min(Math.max(completionPercent, 0), 100);
    const currentColor = color !== null && color !== void 0 ? color : 'default';
    return (React.createElement("div", { className: `progress-bar-bounding progress-bar-${currentColor}` },
        currentColor === 'default' && React.createElement(Icon_1.default, { icon: "clock_purple" }),
        currentColor === 'default' && React.createElement(Spacer_1.default, { size: "xs" }),
        React.createElement("div", { className: "progress-bar-content" },
            React.createElement("div", { className: "progress-bar-status bold" },
                percent,
                "%"),
            React.createElement("div", { className: "progress-bar-container" },
                React.createElement("div", { className: "progress-bar-line full" }),
                React.createElement("div", { className: "progress-bar-line progress", style: {
                        transition: `width ${transitionPeriod}s`,
                        width: `${percent}%`,
                    } })))));
};
exports.ProgressBar = ProgressBar;
//# sourceMappingURL=ProgressBar.js.map